import { initConsoleIntegration } from './integrations/console'
import { initRumIntegration } from './integrations/rum'
import { getConfig } from '@/tools/config'

export const initRum = () => {
  const { env } = getConfig()

  // Often developers run prod environment locally, during development processes, we need
  // an additional check to capture those events and pr3vent metric emission to Datadog as they
  // are not relevant and introduce noise.
  const isDevelopmentEnv = env === 'development' || location.hostname === 'localhost'
  const isBrowser = typeof window !== 'undefined'
  const shouldUseRum = env === 'prod' || env === 'stage'

  if (isBrowser && shouldUseRum && !isDevelopmentEnv) {
    initRumIntegration()
  } else {
    initConsoleIntegration()
  }
}
